import { Component, OnInit, Inject } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/filter';
import { DOCUMENT } from '@angular/platform-browser';
import { Global } from './@core/lib/global';
import { DeviceService } from './@core/services/device.service';

declare const $: any;
declare const BroadcastChannel: any;

@Component({
  selector: 'app-my-app',
  templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {

  private _router: Subscription;
  public window: any = window;
  public textWait: any;
  constructor(
    private router: Router,
    public global: Global,
    private deviceService: DeviceService,
    @Inject(DOCUMENT) private document: any
  ) {
    this.router.events.subscribe((evt) => {
      window['app_global'] = this.global;
      if (evt instanceof NavigationStart) {
        this.global.loading = true;
      }
      if (evt instanceof NavigationEnd) {
        this.global.loading = false;
        setTimeout(() => {
          $('html, body, window, .main-panel').animate({ scrollTop: 0 }, '500');
        }, 100);
      }
    });
  }

  ngOnInit() {
    // Se o usuário já estiver logado (F5 direto em páginas internas), inicializa o dispositivo
    if (sessionStorage.getItem('token') || sessionStorage.getItem('loggedUser')) {
      this.deviceService.initDevice();
    }
    this.listenBroadcastChannel();
    $.material.options.autofill = true;
    $.material.init();
    this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
      if (window.outerWidth > 991) {
        window.document.children[0].scrollTop = 0;
      }
      else {
        window.document.activeElement.scrollTop = 0;
      }
    });
  }

  public listenBroadcastChannel() {
    const channel = new BroadcastChannel('asap-admin-channel');
    channel.onmessage = (event) => {
      console.log('[AppComponent] Listening Broadcast', event);
    };

  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts